import { useMemo } from 'react';
import {
  Text,
  HStack,
  IconButton,
  Icon,
  ReactTable,
} from '@wegroup/design-system';
import { UploadResponse } from '../../../../../../../../common/src/hooks/useUpload';
import { PartyDocument } from '../../../../../../../../parties/src/types';
import { InsurancePolicy } from '@advisory-report/src/types/AdvisoryReport';
import { useTranslation } from 'react-i18next';

export const InsurancePolicyItemCardDocuments = (props: {
  insurancePolicy: InsurancePolicy;
}) => {
  const { insurancePolicy } = props;
  const { t } = useTranslation();
  const handleDocumentDownload = (document: UploadResponse | PartyDocument) => {
    if ('link' in document && document.link) {
      window.open(document.link, '_blank');
    }
  };

  const data =
    insurancePolicy.documents
      ?.map((document, index) => ({
        id: 'id' in document ? document.id : index,
        filename: document.filename,
        link: 'link' in document ? document.link : '',
        document,
      }))
      // extra filter to not have empty links, just in case
      .filter((document) => document.link) || [];

  const columns = useMemo(
    () => [
      {
        Header: t('Documents'),
        accessor: 'filename',
        disableSortBy: true,
        Cell: ({ value }: { value: string }) => (
          <Text textStyle="smallBody">{value}</Text>
        ),
      },
      {
        Header: '',
        accessor: 'link',
        disableSortBy: true,
        Cell: ({
          row,
        }: {
          row: {
            original: {
              document: UploadResponse | PartyDocument;
              link: string;
            };
          };
        }) => (
          <HStack justify="flex-end">
            <IconButton
              variant="white"
              size="sm"
              aria-label="Download document"
              icon={<Icon name="GeneralActionsDownload" />}
              onClick={() => handleDocumentDownload(row.original.document)}
              isDisabled={!row.original.link}
            />
          </HStack>
        ),
      },
    ],
    [],
  );

  return (
    <ReactTable
      variant="borderless"
      data={data}
      columns={columns}
      borderBottom="none"
    />
  );
};
